import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { ActionIcon, Button, Center } from "@mantine/core";
import SRD_DataTable from "components/DataTable";
import { getManualList } from "../apis/adminManualApis";
import { download } from "pages/Admin/Library/apis/adminLibraryApis";
import { useQuery } from "react-query";
import { useRecoilState } from "recoil";
import { userState } from "pages/Login/atom/userState";
import { PAGE_SIZE } from "CommonData";

function ManualDataTable() {
  const navigate = useNavigate();
  const [user, setUser] = useRecoilState(userState);
  const groupId = user.fn_group_id;

  const [page, setPage] = useState(1);

  const { data } = useQuery(["manualLists", page], () =>
    getManualList(PAGE_SIZE, page, groupId)
  );

  useEffect(() => {
    if (!data || data?.length < 1) return;
    data.map((item) => {
      let used_scope = "전체";
      if (item.menu !== "M"){
        used_scope = "그룹 내부";
      }
      item["used_scope"] = used_scope;
    });
  });

  const columns = [
    {
      accessor: "index",
      title: "번호",
      textAlignment: "center",
      width: 30,
      render: (record) => record?.rnum,
    },
    {
      accessor: "used_scope",
      title: "공개범위",
      textAlignment: "center",  
    },
    {
      accessor: "title",
      title: "제목",
      cellsStyle: {
        color: "blue",
 //       textDecoration: "underline",
      },
      onClick: function (e) {
        navigate(`/admin/manual/${e.record.no}`);
      },
    },
    {
      accessor: "registration_date",
      title: "등록일",
    },
    {
      accessor: "file_type",
      title: "파일 형식",
    },
    {
      accessor: "download_link",
      title: "다운로드",
      cellsStyle: {
        color: "blue",
        textDecoration: "underline",
      },
      width: 80,
      render: (e) => (
        <Center>
          <ActionIcon onClick={() => download(e)}>
            <img
              src="https://api.iconify.design/bi:file-earmark-arrow-down.svg?color=Black"
              alt="download"
            />
          </ActionIcon>
        </Center>
      ),
    },
  ];

  const RegisterButton = () => {
    return (
      <Button variant="default" onClick={() => navigate("/admin/manual/add")}>
        등록관리
      </Button>
    );
  };
  return (
    <SRD_DataTable
      data={data}
      columns={columns}
      registerButton={<RegisterButton />}
      page={page}
      setPage={setPage}
    />
  );
}

export default ManualDataTable;
